import {i18n} from "@/plugins/i18n";

export const statementTransferType = {
    PAYA: 1,
    SATNA: 2,
    INTERNAL: 3,
    CARD_TO_CARD: 4,
    POL: 5,
    TRANSFER: 6,
    PURCHASE: 7,
    BANK_WAGE: 8,
    REFUND: 9,
    ATM: 10,
    POS: 11,
    CASH: 12,
    SHAPARAK: 13,
    BILL: 14,
};

export const statementTransferTypeStr = {
    PAYA: i18n.t('open_banking.transfer_type.paya'),
    SATNA: i18n.t('open_banking.transfer_type.satna'),
    INTERNAL: i18n.t('open_banking.transfer_type.internal'),
    CARD_TO_CARD: i18n.t('open_banking.transfer_type.card_to_card'),
    POL: i18n.t('open_banking.transfer_type.pol'),
    TRANSFER: i18n.t('open_banking.transfer_type.transfer'),
    PURCHASE: i18n.t('open_banking.transfer_type.purchase'),
    BANK_WAGE: i18n.t('open_banking.transfer_type.bank_wage'),
    REFUND: i18n.t('open_banking.transfer_type.refund'),
    ATM: i18n.t('open_banking.transfer_type.atm'),
    POS: i18n.t('open_banking.transfer_type.pos'),
    CASH: i18n.t('open_banking.transfer_type.cash'),
    SHAPARAK: i18n.t('open_banking.transfer_type.shaparak'),
    BILL: i18n.t('open_banking.transfer_type.bill'),

    get(type) {
        let type_str = null;

        Object.keys(statementTransferType).forEach(item => {
            if (statementTransferType[item] === type) {
                type_str = statementTransferTypeStr[item];
            }
        });

        return type_str;
    }
};